var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionRealEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 29.625H9L11.75 32.375H28.25L31 29.625H37.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 7.625H24.125V18.625C24.125 19.3544 23.8353 20.0538 23.3196 20.5696C22.8038 21.0853 22.1044 21.375 21.375 21.375H18.625C17.8956 21.375 17.1962 21.0853 16.6804 20.5696C16.1647 20.0538 15.875 19.3544 15.875 18.625V7.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.125 29.625V25.4999C35.1286 22.2073 34.0558 19.0038 32.07 16.3775C30.084 13.7511 27.294 11.846 24.125 10.9524",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 10.9524C12.706 11.846 9.91598 13.7511 7.93012 16.3775C5.94424 19.0038 4.87138 22.2073 4.87501 25.4999V29.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionRealEstate);
export default __webpack_public_path__ + "static/media/ConstructionRealEstate.fa943d54b4526c85d700c2d78c91c14c.svg";
export { ForwardRef as ReactComponent };